import React from 'react';

const StepObjectives = ({ formData, updateFormData, nextStep, prevStep, disabled }) => {
  const data = formData.objectives;

  const handleChange = (field, value) => {
    updateFormData('objectives', { [field]: value });
  };

  return (
    <fieldset disabled={disabled}>
      <h4 className="soa-step-title">Objectives &amp; Goals</h4>
      <p className="soa-step-subtitle">Document what the client wants to achieve with this advice</p>

      <div className="row">
        <div className="col-md-6 soa-form-group">
          <label>Target Retirement Age</label>
          <input
            type="number"
            className="form-control"
            value={data.retirementAge}
            onChange={(e) => handleChange('retirementAge', e.target.value)}
            placeholder="e.g. 65"
          />
        </div>
        <div className="col-md-6 soa-form-group">
          <label>Desired Retirement Income ($ p.a.)</label>
          <input
            type="number"
            className="form-control"
            value={data.incomeNeeds}
            onChange={(e) => handleChange('incomeNeeds', e.target.value)}
            placeholder="e.g. 80000"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 soa-form-group">
          <label>Capital Growth Objective</label>
          <select className="form-select" value={data.capitalGrowth} onChange={(e) => handleChange('capitalGrowth', e.target.value)}>
            <option value="">Select...</option>
            <option value="Capital preservation">Capital preservation</option>
            <option value="Moderate growth">Moderate growth</option>
            <option value="Strong growth">Strong growth</option>
            <option value="Maximum growth">Maximum growth</option>
          </select>
        </div>
        <div className="col-md-6 soa-form-group">
          <label>Investment Time Horizon (years)</label>
          <input
            type="number"
            className="form-control"
            value={data.timeHorizon}
            onChange={(e) => handleChange('timeHorizon', e.target.value)}
            placeholder="e.g. 10"
          />
        </div>
      </div>

      <div className="soa-form-group">
        <label>Specific Goals</label>
        <textarea
          className="form-control"
          value={data.specificGoals}
          onChange={(e) => handleChange('specificGoals', e.target.value)}
          placeholder="e.g. Pay off mortgage within 5 years, fund children's education, travel in retirement, leave an estate for family..."
          rows={4}
        />
      </div>

      <div className="soa-form-group">
        <label>Additional Notes</label>
        <textarea
          className="form-control"
          value={data.notes}
          onChange={(e) => handleChange('notes', e.target.value)}
          placeholder="Any other relevant objectives or constraints"
          rows={2}
        />
      </div>

      <div className="soa-step-nav">
        <button className="btn btn-outline-secondary" onClick={prevStep}>
          <i className="bi bi-arrow-left me-1"></i>Back
        </button>
        <button className="btn btn-primary" onClick={nextStep}>
          Next: Risk Profile <i className="bi bi-arrow-right ms-1"></i>
        </button>
      </div>
    </fieldset>
  );
};

export default StepObjectives;
